export default __webpack_public_path__ + "static/media/logo.84779d30.svg";